<div class="actions">
  <div class="action">
    <a *ngIf="data.downloadUrl" [href]="data.downloadUrl" target="_blank">
      <mat-icon svgIcon="pdf" class="_common-icon--theme" title="View Plan"></mat-icon>
    </a>
  </div>
</div>
